import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "./locales/en.json";
import it from "./locales/it.json";

const resources = {
  en: {
    translation: en,
  },
  it: {
    translation: it,
  },
};

i18n
  .use(LanguageDetector) // Detect user language from browser
  .use(initReactI18next) // Pass i18n instance to react-i18next
  .init({
    resources,
    fallbackLng: "en",
    supportedLngs: ["en", "it"],
    debug: false,
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    detection: {
      // Order: first check localStorage, then browser language
      order: ["localStorage", "navigator"],
      // Save to localStorage when language changes
      caches: ["localStorage"],
      lookupLocalStorage: "i18nextLng",
    },
  });

// La lingua della pagina segue quella scelta (index.html parte da "en").
const aggiornaLang = (lng) => {
  if (typeof document !== "undefined" && lng) document.documentElement.lang = lng;
};
aggiornaLang(i18n.language);
i18n.on("languageChanged", aggiornaLang);

// Hot-reload translations in dev: i18next loads resources once at init, so
// edits to the locale JSON wouldn't show until a full page reload. This pushes
// the updated bundles into the running store and re-renders.
if (import.meta.hot) {
  import.meta.hot.accept(
    ["./locales/en.json", "./locales/it.json"],
    ([newEn, newIt]) => {
      if (newEn?.default) {
        i18n.addResourceBundle("en", "translation", newEn.default, true, true);
      }
      if (newIt?.default) {
        i18n.addResourceBundle("it", "translation", newIt.default, true, true);
      }
      // Force react-i18next consumers to re-render with the new strings.
      i18n.changeLanguage(i18n.language);
    }
  );
}

export default i18n;
